<template>
	<div v-if="!locked" class="audio-box panel gray-small-square-1">

		<div class="shadow left"></div>
		<div class="shadow top"></div>
		<div class="shadow right"></div>
		<div class="shadow bottom"></div>
		<div v-if="step1.visible" class="step-1">
			<div class="timer">
				{{ counter }}
			</div>
			<div class="seconds">
				Seconds
			</div>
		</div>
		<div v-if="step2.visible" class="step-2">
			<div class="icon" :class="{ muted: part.EscutouAudio }"></div>
			<div v-if="!part.EscutouAudio" class="player">
				<div class="time">
					<span class="start">{{ player.time }}</span>
					<span class="end">{{ player.duration }}</span>
				</div>
				<div class="progress-bar">
					<div :style="{ width: player.bar + '%' }" class="bar"></div>
				</div>

			</div>
			<div class="text">
				{{ text }}
			</div>
			<div class="buttons">
				<button 
				@click="previous" 
				class="btn btn-gray previous left">Previous</button>
				<next 
				:is-last-page="true"
				:click="next" 
				:part="part"></next>
			</div>
		</div>
	</div>
</template>

<script>
	import soundManager from '@/audio/sound-manager.js'
	import bus from '@/bus/event-bus.js'
	import next from '../../ui/NextButton'

	
	export default {
		props: ['part', 'locked'],

		data() {
			return {
				interval: null,
				partId: null,
				counter: 3,
				step1: {
					visible: false,
				},
				audio: null,
				player: {
					durationMs: 0,
					time: '0:00',
					duration: '',
					bar: 0
				},
				step2: {
					visible: false,
					audioPlaying: false
				}
			}
		},

		computed: {

			text() {
				if(this.step2.audioPlaying) 
					return "";

				return "Answer the questions";

			}
		},

		watch: {
			part() {
				if(this.part.PartId !== this.partId) {
					this.init()
				}
			}
		},

		mounted() {

			if(this.locked) return;

			this.init()
		},

		beforeDestroy() {
			this.finish()
		},

		methods: {

			init() {

				if(this.audio != null) {
					this.audio.stop()
				}

				this.player = {
					durationMs: 0,
					time: '0:00',
					duration: '',
					bar: 0
				}

				this.step2 = {
					visible: false,
					audioPlaying: false,
				}

				this.counter = this.part.PartTempoLeituraPerguntas

				this.step1 = {
					visible: false
				}

				this.partId = this.part.PartId
				if(!this.part.EscutouAudio) {
					this.audio = this.makeAudio();
					this.audio.load()
					this.step2.audioPlaying = true;
					this.firstStep();
				} else {
					this.step2.visible = true;
				}
			},

			firstStep() {
				bus.$emit('audio.started');
				this.step1.visible = true;
				this.interval = setInterval(() => {
					this.counter--;
					if(this.counter === 0) {
						this.secondStep();
					}
				}, 1000)

			},

			next() {
				bus.$emit('next.part');
			},

			previous() {
				bus.$emit('previous.part');
			},

			makeAudio() {
				var that = this
				soundManager.destroySound(this.part.PartId)
				return soundManager.createSound({
					id: this.part.PartId,
					url: this.part.PartMedia,
					onload: function() {
						that.player.duration = that.formatMs(this.duration)
						that.player.durationMs = that.audio.duration
					}
				});
			},

			playAudio(callback) {
				var that = this;
				this.audio.play({
					whileplaying: function() {
						that.player.time = that.formatMs(this.position)
						that.player.bar = (this.position / that.player.durationMs) * 100;
					},
					onfinish: function() {
						callback();
					}
				})
			},

			formatMs(millis) {
				var minutes = Math.floor(millis / 60000);
				var seconds = ((millis % 60000) / 1000).toFixed(0);
				return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
			},

			finish() {

				if(!this.part.EscutouAudio) {
					bus.$emit('audio.played', this.part);
				}

				if(this.audio != null) {
					this.audio.stop()
				}

				this.step2.audioPlaying = false
				clearInterval(this.interval)
				soundManager.destroySound(this.part.PartId)
				
			},

			secondStep() {
				clearInterval(this.interval)
				this.step1.visible = false
				this.step2.visible = true
				this.playAudio(() => {
					this.finish()
				})
			}
		},
		components: {
			'next': next
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/audio/AudioBox.vue